import isEmpty from 'lodash/isEmpty';
import { getUrlImagePath, isCurrentPageRedirectFromRNA, isMobileDevice, isIos, isSafari } from 'common/utilities/utils';

import {
  IMAGE_SIZE_CONSTANTS,
  INPUT,
  ROUTE_URL,
  GIFT_CARD,
  FORM_FIELD_TYPE,
  OTHER,
  CURRENCY_CONSTANTS,
  SESSION_STORAGE_KEYS,
  PURCHASE_TYPE,
} from 'common/constants/SharedConstants';
import { setPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { RESTRICTED_BAD_WORDS } from 'common/constants/restrictionWords';
import { checkRestrictedWords } from 'organisms/AccountPage/AU/accountPageUtils';
import { paymentForGiftCard } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import { resetGiftcardCheckBal } from '@kfc-global/react-shared/redux/Actions/GiftCheckBalanceAction';
import { GIFTCARD_CONSTANTS } from '../Constants/giftcardConstants';
const { GIFT_CARD_ITEMS } = IMAGE_SIZE_CONSTANTS;

export const getGiftCardContentData = fields => {
  const items = fields.body?.map(item => item.fields);
  if (!isEmpty(items) && GIFT_CARD === fields.title) {
    return {
      headLine: items[0]?.headline,
      desktopImage: getUrlImagePath(
        items[0]?.image1?.fields?.file?.url,
        GIFT_CARD_ITEMS.BANNER_WIDTH_DESKTOP,
        GIFT_CARD_ITEMS.BANNER_HEIGHT_DESKTOP,
      ),
      mobileImage: getUrlImagePath(
        items[0]?.image?.fields?.file?.url,
        GIFT_CARD_ITEMS.BANNER_WIDTH_MOBILE,
        GIFT_CARD_ITEMS.BANNER_HEIGHT_MOBILE,
      ),
      phoneNumberRegex: items[1].formField[0].fields.pattern,
      subHeadline: items[0]?.subHeadline,
      description: items[0]?.description,
      resendCardDetailsButtonText: items[0]?.button?.fields?.buttonText,
      giftCardAmountOptions: items[3]?.formField?.[0]?.fields.values,
      yourInfoFormHeadline: items[2]?.headline,
      giftCardDetailsFormHeadline: items[3]?.headline,
      additionalInfoHeadline: items[6]?.headline,
      termsCondtionsLink: items[6]?.formField[0].fields.linkText,
      addAnotherGiftCard: items[3]?.formField[4].fields.buttonText,
      goToPaymentButton: items[4]?.buttonText,
      faqText: items[6]?.formField[1]?.fields.headline,
      faqLink: items[6]?.formField[2]?.fields.linkText,
      faqUrl: items[6]?.formField[2]?.fields.internalurl,
      termsCondtionsUrl: items[6]?.formField[0]?.fields.internalurl,
      checkCardDetailsModalTitle: items[1]?.headline,
      checkCardDetailsModalContent: items[1]?.subHeadline,
      checkCardDetailsModalInput: items[1]?.formField[0]?.fields.label,
      linkImageBlack: items[5]?.image.fields.file.url,
      linkImageWhite: items[4]?.image.fields.file.url,
      checkCardDetailsModalButtonText: items[1]?.formField[1]?.fields.buttonText,
      confirmAmountButtonText: items[3]?.formField[1]?.fields?.buttonText,
      minAmount: items[3].formField[0].fields.maximumAmount,
      maxAmount: items[3].formField[0].fields.minimumAmount,
    };
  }
};

export const onCustomerFormElementChangeHandler = formConfig => {
  const fieldValues = formConfig?.getValueFromElements?.();
  const customerDetails = { ...formConfig?.customerDetails };
  if (fieldValues !== undefined) {
    customerDetails.customerName = fieldValues?.customerName;
    customerDetails.customerEmail = fieldValues?.customerEmail;
  }
  customerDetails.isFormValid = formConfig?.isFormValid;
  formConfig?.updateGiftCardDetails({
    customerDetails: {
      ...customerDetails,
    },
  });
};

export const prepareCustomerFormData = giftCardData => {
  const dataUpdated = [];
  giftCardData?.items?.[0]?.fields.body?.[2]?.fields?.formField.forEach(formElement => {
    const {
      fields,
      sys: { id },
    } = formElement;
    const returnData = {
      ...fields,
      className: 'formElement',
      key: id,
      rules: {
        required: {
          value: formElement?.fields?.required ? formElement?.fields?.required : false,
          message: `${translateWithI18Next(
            TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
          )} ${formElement.fields.description.content[0].content[0].value.toLowerCase()}`,
        },
        pattern: {
          value: formElement?.fields?.pattern ? RegExp(formElement?.fields?.pattern) : null,
          message: `${translateWithI18Next(
            TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
          )} ${formElement.fields.description.content[0].content[0].value.toLowerCase()}`,
        },
        validate: textvalue =>
          formElement?.fields?.type === INPUT
            ? !checkRestrictedWords(RESTRICTED_BAD_WORDS, textvalue) ||
              `${translateWithI18Next(
                TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
              )} ${formElement.fields.description.content[0].content[0].value.toLowerCase()}`
            : true,
      },
      onChangeHandler: onCustomerFormElementChangeHandler,
      onBlurHandler: onCustomerFormElementChangeHandler,
      isMandatory: formElement?.fields?.required ? formElement?.fields?.required : false,
      maxLength: formElement?.fields?.maxLength ? formElement?.fields?.maxLength : '',
      value: '',
    };
    dataUpdated.push(returnData);
  });
  return dataUpdated;
};

const getRecipientDetailsConfig = ({ dataUpdated, returnData, formElement }) => {
  dataUpdated.push({
    ...returnData,
    rules: {
      required: {
        value: formElement?.fields?.required,
        message: `${translateWithI18Next(
          TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
        )} ${formElement?.fields?.label?.toLowerCase()}`,
      },
      pattern: {
        value: RegExp(formElement?.fields?.pattern),
        message: `${translateWithI18Next(
          TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
        )} ${formElement?.fields?.label?.toLowerCase()}`,
      },
      validate: textvalue =>
        formElement?.fields?.type === INPUT
          ? !checkRestrictedWords(RESTRICTED_BAD_WORDS, textvalue) ||
            `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.INVALID_TEXT)} ${formElement?.fields?.label?.toLowerCase()}`
          : true,
    },
    onChangeHandler: onRecipientFormFieldHandler,
    onBlurHandler: onRecipientFormFieldHandler,
    isMandatory: formElement?.fields?.required,
    maxLength: formElement?.fields?.maxLength,
  });
};

export const onGiftCardAmountBlurHandler = formConfig => {
  const details = formConfig?.giftCardDetails?.recipientDetails;
  details[formConfig?.name].giftCardAmountOtherDirty = false;
  formConfig?.updateGiftCardDetails({ recipientDetails: details });
};

export const onGiftCardAmountFocusHandler = formConfig => {
  const details = formConfig?.giftCardDetails?.recipientDetails;
  details[formConfig?.name].giftCardAmountOtherDirty = true;
  formConfig?.updateGiftCardDetails({ recipientDetails: details });
};

export const getRecipientGiftCardAmtConfig = ({ dataUpdated, returnData, giftCardDetails, formElement }) => {
  dataUpdated.push({
    ...returnData,
    type: FORM_FIELD_TYPE?.TILES_BUTTON_GROUP,
    source: giftCardDetails?.recipientAmountPanelConfig?.tileButtonGroupSource,
    onClickHandler: onRecipientFormFieldHandler,
  });
  dataUpdated.push({
    ...returnData,
    name: `${formElement?.fields?.name}${OTHER}`,
    type: FORM_FIELD_TYPE?.INPUT,
    onChangeHandler: onRecipientFormFieldHandler,
    onBlurHandler: onGiftCardAmountBlurHandler,
    onFocusHandler: onGiftCardAmountFocusHandler,
    isMandatory: formElement?.fields?.required,
    showClearTextInputBtn: (formConfig, fieldsConfig) =>
      fieldsConfig?.name === GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER &&
      !isEmpty(formConfig?.getValueFromElements?.()?.[GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER]) &&
      !formConfig?.giftCardDetails?.recipientDetails[formConfig?.name]?.customTipSelected,
    showEditTextInputBtn: formConfig =>
      formConfig?.giftCardDetails?.recipientDetails[formConfig?.name]?.customTipSelected,
    conditionalRender: (formConfig, fieldsConfig) =>
      fieldsConfig?.name === GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER &&
      formConfig?.getValueFromElements?.()?.[GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT]?.toLowerCase?.() ===
        OTHER?.toLowerCase?.(),
    onClearButtonClickHandler: (formConfig, fieldsConfig) =>
      fieldsConfig?.name === GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER &&
      formConfig?.setValueToFormElements(GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER, ''),
    onEditButtonClickHandler: (formConfig, fieldsConfig) => onGiftCardAmountEditHandler(formConfig, fieldsConfig),
    prefix: (formConfig, fieldsConfig) =>
      fieldsConfig?.name === GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER &&
      (!isEmpty(formConfig?.getValueFromElements?.()?.[GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER]) ||
        formConfig?.giftCardDetails?.recipientDetails[formConfig?.name]?.giftCardAmountOtherDirty)
        ? giftCardDetails?.currencySymbol
        : '',
    readonly: formConfig => isReadOnly(formConfig),
    updatedValue: (formConfig, fieldsConfig) => getUpdatedValue(formConfig, fieldsConfig),
    rules: {
      validate: (value, formValues) =>
        validateCustomAmtInput({ textValue: value, formValues, formElement, giftCardDetails }),
    },
  });
};

export const getUpdatedValue = (formConfig, fieldsConfig) =>
  formConfig?.giftCardDetails?.recipientDetails[formConfig?.name]?.customTipSelected
    ? parseInt(fieldsConfig?.value) + CURRENCY_CONSTANTS
    : fieldsConfig?.value;

export const isReadOnly = formConfig =>
  formConfig?.giftCardDetails?.recipientDetails[formConfig?.name]?.customTipSelected ? true : false;

export const onGiftCardAmountEditHandler = (formConfig, fieldsConfig) => {
  const formName = formConfig?.name;
  const recipientDetails = [...formConfig?.giftCardDetails?.recipientDetails];
  if (fieldsConfig) {
    recipientDetails[formName].isFormValid = false;
    recipientDetails[formName].customTipSelected = false;
  }
  formConfig?.updateGiftCardDetails?.({ recipientDetails: recipientDetails });
};

export const validateCustomAmtInput = ({ formValues, formElement, giftCardDetails }) => {
  const giftCardAmt =
    formValues?.giftCardAmount === OTHER
      ? parseInt(formValues?.giftCardAmountOther)
      : parseInt(formValues?.giftCardAmount);

  if (giftCardDetails?.recipientDetails?.[formValues?.hiddenField]?.giftCardAmountOtherDirty) {
    if (
      isNaN(giftCardAmt) ||
      isEmpty(formValues?.giftCardAmount) ||
      (formValues?.giftCardAmount === OTHER &&
        (isEmpty(formValues?.giftCardAmountOther) || !/^\d+$/.test(formValues?.giftCardAmountOther)))
    ) {
      return `${translateWithI18Next(
        TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
      )} ${formElement?.fields?.label?.toLowerCase()}`;
    }
  }

  if (giftCardAmt === 0) {
    return `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.INVALID_TEXT)} ${formElement?.fields?.label?.toLowerCase()}`;
  } else if (giftCardAmt > formElement?.fields?.maximumAmount) {
    return `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.MAX_AMOUNT_INAVLAID_MSG)}`;
  } else if (giftCardAmt < formElement?.fields?.minimumAmount) {
    return `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.MIN_AMOUNT_INVALID_MSG)}`;
  } else {
    return true;
  }
};

export const validateConfirmationBtn = ({ formValues, giftCardDetails }) =>
  giftCardDetails?.recipientDetails?.[formValues?.hiddenField]?.giftCardAmount === OTHER
    ? giftCardDetails?.recipientDetails?.[formValues?.hiddenField]?.customTipSelected
    : true;

export const prepareRecipientFormData = params => {
  const { giftCardDetails, giftCardContent } = params;
  const dataUpdated = [];
  giftCardContent?.items?.[0]?.fields.body?.[3]?.fields?.formField.forEach(formElement => {
    const {
      fields,
      sys: { id },
    } = formElement;
    const returnData = {
      ...fields,
      key: id,
      name: formElement?.fields?.name,
    };
    if (formElement?.fields?.name === GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT) {
      getRecipientGiftCardAmtConfig({ dataUpdated, returnData, giftCardDetails, formElement });
    } else if (formElement?.fields?.name === GIFTCARD_CONSTANTS.CONFIRM_AMOUNT_BUTTON) {
      dataUpdated.push({
        ...returnData,
        type: FORM_FIELD_TYPE?.BUTTON,
        label: formElement?.fields?.buttonText,
        onClickHandler: onRecipientFormFieldHandler,
        conditionalRender: (formConfig, fieldsConfig) =>
          formConfig?.getValueFromElements?.()?.[GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT]?.toLowerCase?.() ===
            OTHER?.toLowerCase?.() &&
          !formConfig?.giftCardDetails?.recipientDetails[formConfig?.name]?.customTipSelected,
        disabled: (formConfig, fieldsConfig) =>
          isEmpty(formConfig?.getValueFromElements?.()?.[GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER]) ||
          !isEmpty(formConfig?.errors?.giftCardAmountOther),
        rules: {
          validate: (value, formValues) =>
            validateConfirmationBtn({ textValue: value, formValues, formElement, giftCardDetails }),
        },
      });
    } else if (formElement?.fields?.name !== GIFTCARD_CONSTANTS.ADD_ANOTHER_GIFT_CARD) {
      getRecipientDetailsConfig({ dataUpdated, returnData, formElement });
    }
  });
  return dataUpdated;
};

export const onRecipientFormFieldHandler = (formConfig, fieldsConfig) => {
  const fieldValues = formConfig?.getValueFromElements?.();
  const formName = formConfig?.name;
  const recipientDetails = [...formConfig?.giftCardDetails?.recipientDetails];
  if (fieldsConfig) {
    const fieldValue =
      fieldsConfig?.name === GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT
        ? fieldValues?.[fieldsConfig?.name]?.detail?.value
        : fieldValues?.[fieldsConfig?.name];
    recipientDetails[formName][fieldsConfig?.name] = fieldValue;

    if (fieldsConfig?.name === GIFTCARD_CONSTANTS.CONFIRM_AMOUNT_BUTTON) {
      recipientDetails[formName].customTipSelected =
        recipientDetails?.[formName]?.giftCardAmount?.toLowerCase?.() === OTHER?.toLowerCase?.() &&
        !isNaN(parseInt(recipientDetails?.[formName]?.giftCardAmountOther?.trim()));
    }
    fieldsConfig?.name === GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT &&
      formConfig?.setValueToFormElements?.(GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT, fieldValue);
  }

  if (recipientDetails?.[formName]?.giftCardAmount?.toLowerCase?.() !== OTHER?.toLowerCase?.()) {
    recipientDetails[formName].giftCardAmountOther = '';
    recipientDetails[formName].customTipSelected = false;
    recipientDetails[formName].giftCardAmountOtherDirty = false;
    formConfig?.resetFormFieldValues(GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER, { keepDirty: false });
    formConfig?.setValueToFormElements?.(GIFTCARD_CONSTANTS.GIFT_CARD_AMOUNT_OTHER, '');
  }

  recipientDetails[formName].isFormValid = formConfig?.isFormValid;
  formConfig?.updateGiftCardDetails?.({ recipientDetails: recipientDetails });
};

export const validatePreviousRecipientForm = giftCardDetails => {
  return giftCardDetails?.recipientDetails?.every(
    recipientDetail =>
      recipientDetail?.isFormValid &&
      (recipientDetail?.giftCardAmount === OTHER
        ? recipientDetail?.giftCardAmountOther
        : recipientDetail?.giftCardAmount),
  );
};

export const validateAllForm = giftCardDetails =>
  giftCardDetails?.customerDetails?.isFormValid &&
  giftCardDetails?.recipientDetails?.every(
    recipientDetail =>
      recipientDetail?.isFormValid &&
      (recipientDetail?.giftCardAmount === OTHER
        ? recipientDetail?.giftCardAmountOther
        : recipientDetail?.giftCardAmount),
  );

export const getClassNameforGoToPaymentButton = giftCardDetails =>
  validateAllForm(giftCardDetails) ? 'mt-4 goToPaymentButton' : 'mt-4 goToPaymentButton-disabled';

export const getClassNameforAnotherRecipientButton = giftCardDetails =>
  `${
    isIos() || isSafari()
      ? 'button whiteButton blackBorder resendcard-details resendcard-details-safari'
      : 'button whiteButton blackBorder resendcard-details'
  }`;

export const paymentButtonClickHandler = (giftCardDetails, updateGiftCardDetails, dispatch) => {
  sessionStorage.setItem(SESSION_STORAGE_KEYS.POST_PAYMENT_TYPE, PURCHASE_TYPE.GIFT_CARD_PURCHASE);
  const transactionDate = new Date().toISOString().slice(0, -5);
  updateGiftCardDetails({ isGoToPaymentButtonClicked: true });
  const siteOrigin = window.location.origin + ROUTE_URL.ORDER_PROCESSING;
  const recipientsData = giftCardDetails?.recipientDetails?.map(recipientDetail => ({
    name: recipientDetail.recipientName,
    phoneNumber: recipientDetail.recipientPhoneNumber,
    amount:
      recipientDetail.giftCardAmount !== OTHER
        ? parseInt(recipientDetail.giftCardAmount) * giftCardDetails?.currencyConversionFactor
        : parseInt(recipientDetail.giftCardAmountOther) * giftCardDetails?.currencyConversionFactor,
  }));
  dispatch(setPWAstorage({ key: 'giftCardDataRecipientDetails', value: giftCardDetails?.recipientDetails }));
  dispatch(setPWAstorage({ key: 'giftCardDataCustomerDetails', value: giftCardDetails?.customerDetails }));
  dispatch(setPWAstorage({ key: 'loggedIn', value: giftCardDetails?.userParams?.loggedIn }));
  const payload = {
    customer: {
      id: giftCardDetails?.userParams?.loggedIn ? giftCardDetails?.customerDetails?.customerId : '',
      firstName: giftCardDetails?.customerDetails?.customerName,
      lastName: giftCardDetails?.userParams?.loggedIn ? giftCardDetails?.customerDetails?.lastName : '',
      email: giftCardDetails?.customerDetails?.customerEmail,
      phoneNumber: giftCardDetails?.userParams?.loggedIn ? giftCardDetails?.customerDetails?.phone : '',
      isRegistered: giftCardDetails?.userParams?.loggedIn,
    },
    purchaser: {
      name: giftCardDetails?.customerDetails?.customerName,
      email: giftCardDetails?.customerDetails?.customerEmail,
    },
    recipients: recipientsData,
    transactionDate: transactionDate,
    lang: 'en-ZA',
  };
  dispatch(
    paymentForGiftCard({
      tenantId: giftCardDetails?.tenantId,
      siteOrigin,
      data: payload,
    }),
  );
};

export const getBlackOrWhiteIcon = giftCardDetails => {
  return giftCardDetails?.customerDetails?.isFormValid &&
    giftCardDetails?.recipientDetails?.every(
      recipientDetail =>
        recipientDetail?.isFormValid &&
        (recipientDetail?.giftCardAmount === OTHER
          ? recipientDetail?.giftCardAmountOther
          : recipientDetail?.giftCardAmount),
    )
    ? giftCardDetails?.segmentedGiftCardData?.linkImageBlack
    : giftCardDetails?.segmentedGiftCardData?.linkImageWhite;
};

export const getCustomerInfoFromRNA = (pageURL = null) => {
  let isLoggedInUser = null;
  let customerName = null;
  let customerEmail = null;
  if (isCurrentPageRedirectFromRNA(window?.location, pageURL)) {
    const queryParams = new Proxy(new URLSearchParams(window?.location?.search), {
      get: (searchParams, prop) => searchParams?.get?.(prop),
    });
    isLoggedInUser = queryParams?.isLoggedInUser ? queryParams.isLoggedInUser : isLoggedInUser;
    customerName = queryParams?.customerName ? queryParams.customerName : customerName;
    customerEmail = queryParams?.customerEmail ? queryParams.customerEmail : customerEmail;
  }

  return [isLoggedInUser, customerName, customerEmail];
};

/*********************************************************************
 * openExistingCardBalanceModalHandler
 *
 *********************************************************************/
export const openExistingCardBalanceModalHandler = (updateGiftCardDetails, dispatch) => {
  updateGiftCardDetails?.({ openExistingCardBalanceModal: true });
  dispatch?.(resetGiftcardCheckBal?.());
};

/*********************************************************************
 * closeExistingCardBalanceModalHandler
 *
 *********************************************************************/
export const closeExistingCardBalanceModalHandler = (event, updateGiftCardDetails) => {
  event?.preventDefault?.();
  updateGiftCardDetails?.({ openExistingCardBalanceModal: false });
};

/*********************************************************************
 * addRecipientGiftCardPanelHandler
 *
 *********************************************************************/
export const addRecipientGiftCardPanelHandler = (giftCardDetails, updateGiftCardDetails) => {
  const removeRecipientButtonClickedFlag = giftCardDetails?.removeRecipientButtonClicked
    ? giftCardDetails?.removeRecipientButtonClicked
    : false;
  updateGiftCardDetails?.({ removeRecipientButtonClicked: removeRecipientButtonClickedFlag });
  const details = [...giftCardDetails?.recipientDetails];
  const giftCardAmount = giftCardDetails?.recipientDetails?.[details?.length - 1]?.giftCardAmount;
  const giftCardAmountOther =
    giftCardDetails?.recipientDetails?.[details?.length - 1]?.customTipSelected &&
    giftCardDetails?.recipientDetails?.[details?.length - 1]?.giftCardAmountOther
      ? giftCardDetails?.recipientDetails?.[details?.length - 1]?.giftCardAmountOther
      : '';
  details?.push({
    name: details?.length,
    recipientName: '',
    recipientPhoneNumber: '',
    giftCardAmount,
    giftCardAmountOther,
    customTipSelected:
      giftCardAmount?.toLowerCase?.() === OTHER?.toLowerCase?.() && !isNaN(parseInt(giftCardAmountOther.trim())),
    giftCardAmountOtherDirty: false,
    isFormValid: false,
    isDirty: false,
  });
  updateGiftCardDetails?.({ recipientDetails: [...details] });
};

/*********************************************************************
 * onRemoveRecipientGiftCardPanelHandler
 *
 *********************************************************************/
export const onRemoveRecipientGiftCardPanelHandler = (giftCardDetails, updateGiftCardDetails, removeIndex = -1) => {
  removeIndex !== -1 &&
    removeIndex < giftCardDetails?.recipientDetails?.length &&
    giftCardDetails?.recipientDetails?.splice?.(removeIndex, 1);
  removeIndex !== -1 &&
    updateGiftCardDetails?.({
      recipientDetails: [],
      tempRecipientDetails: [
        ...giftCardDetails?.recipientDetails?.map((details, index) => {
          details.name = index;
          return details;
        }),
      ],
    });
  updateGiftCardDetails?.({ removeRecipientButtonClicked: true });
};

/*********************************************************************
 * defaultGiftCardDetails
 *
 *********************************************************************/
export const defaultGiftCardDetails = () => ({
  dispatch: null,
  tenantId: null,
  currencySymbol: null,
  currencyConversionFactor: null,

  segmentedGiftCardData: null,
  customerFormRef: null,
  customerDetails: {},
  customerFormConfig: {},
  recipientFormConfig: {},
  recipientDetails: [],
  tempRecipientDetails: [],
  isMobile: isMobileDevice(window.innerWidth),
  openExistingCardBalanceModal: false,
  isGoToPaymentButtonClicked: false,
  removeRecipientButtonClicked: false,

  recipientAmountPanelConfig: {
    tileButtonGroupSource: null,
    buttonText: null,
    minimumAmount: null,
    maximumAmount: null,
    inputFiledValidErrormsg: '',
    customAmount: '',
    addDonationBtnHandler: true,
    showDonationsCustomFields: false,
    showNonDonationPercentage: true,
    editButtonShow: false,
    showCurrencyField: false,
    isGiftCardFlow: true,
    isAddHopeFlow: false,
  },
  giftCardPayResponse: null,
});
